import axiosInstance from "./axios-order";
import {PHARMA_TOK} from "./general-variables";
import Notification from "./notifications";

export const fetchData = async (url = isRequired("url"), type = isRequired("type"), dataParams = {}, isToken = false, props = {}) => {

    console.log(dataParams)
    if (!navigator.onLine) {
        Notification.danger("لطفا اینترنت خود را چک کنید", "خطا در دسترسی به اینترنت");

        const reRequest = () => {
            if (props.noNetworkCallBack) {
                props.noNetworkCallBack();
            }
            window.removeEventListener('online', reRequest);
        }

        window.addEventListener('online', reRequest);

        return false;
    }
    let isHeaderJson = props.isHeaderJson ? props.isHeaderJson : false;
    let minimalLoader = !!props.minimalLoader
    let isLoader = props.isLoader ? props.isLoader : true;
    let uploadProgress = props.uploadProgress ? props.uploadProgress : () => {};

    if (isLoader) {
        loader(true, minimalLoader)
    }

    let header = isHeaderJson ? {"Content-Type": "application/json; charset=utf-8"} : {};

    if(props.existFile) {
        header = {"Content-Type": "multipart/form-data; boundary"}
    }

    if (isToken) {
        header = {headers: {...header, Authorization: `Bearer ${localStorage.getItem(PHARMA_TOK)}`}};
    }

    if (type === "post") {
        let formData;
        if (isHeaderJson) {
            formData = dataParams;
        } else if(props.existFile) {
            formData = new FormData();
            for (let key in dataParams) {
                formData.append(key, dataParams[key])
            }
        } else {
            formData = new URLSearchParams();
            for (let key in dataParams) {
                formData.append(key, dataParams[key])
            }
        }

        try {
            // console.log(base_url+url);
            const {data, status} = isToken ? await axiosInstance.post(url, formData, {
                ...header,
                onUploadProgress: uploadProgress
            }) : await axiosInstance.post(url, formData);

            if (isLoader) {
                loader(false, minimalLoader);
            }
            console.log(data);
            if (data.status >= 400 && data.status <= 499) {
                if (data.errors) {
                    for (let key in data.errors) {
                        Notification.danger(data.errors[key])
                    }
                } else {
                    Notification.danger("خطای ناخواسته ای پیش آمد")
                }
                return false;
            } else if (status === 200) {
                return data;
            } else {
                Notification.danger("خطای ناخواسته ای پیش آمد");
                return false;
            }

        } catch (e) {
            if (isLoader) {
                loader(false, minimalLoader);
            }
            if (e.response) {
                if (e.response.status === 401) {
                    localStorage.removeItem(PHARMA_TOK);
                    window.location.replace("/login");
                } else if (e.response.status === 403) {
                    for (let key in e.response.data.errors) {
                        Notification.danger(e.response.data.errors[key])
                    }
                    setTimeout(() => {
                        window.location.replace("/");
                    }, 3000)

                } else if (e.response.status >= 400 && e.response.status <= 499) {
                    if (e.response.data.errors) {
                        for (let key in e.response.data.errors) {
                            Notification.danger(e.response.data.errors[key])
                        }
                    } else {
                        Notification.danger("خطای ناخواسته ای پیش آمد")
                    }
                    return false;
                } else {
                    Notification.danger("خطای ناخواسته ای پیش آمد");
                    return false;
                }


            } else {
                Notification.danger("خطای ناخواسته ای پیش آمد");
                return false;
            }
        }

    } else {
        let formData = "?";
        for (let key in dataParams) {
            formData += formData.slice(-1) === "?" ? `${key}=${dataParams[key]}` : `&${key}=${dataParams[key]}`;
        }

        try {
            // console.log(base_url+url);
            const {
                data,
                status
            } = isToken ? await axiosInstance.get(url + formData, header) : await axiosInstance.get(url + formData);
            if (isLoader) {
                loader(false, minimalLoader);
            }
            console.log(data);
            if (data.status >= 400 && data.status <= 499) {
                if (data.errors) {
                    for (let key in data.errors) {
                        Notification.danger(data.errors[key])
                    }
                } else {
                    Notification.danger("خطای ناخواسته ای پیش آمد")
                }
                return false;
            } else if (status === 200) {
                return data;
            } else {
                Notification.danger("خطای ناخواسته ای پیش آمد");
                return false;
            }
        } catch (e) {

            if (isLoader) {
                loader(false, minimalLoader);
            }
            if (e.response) {
                if (e.response.status === 401) {
                    localStorage.removeItem(PHARMA_TOK);
                    window.location.replace("/login");
                } else if (e.response.status === 403) {
                    for (let key in e.response.data.errors) {
                        Notification.danger(e.response.data.errors[key])
                    }
                    setTimeout(() => {
                        window.location.replace("/");
                    }, 3000)
                } else if (e.response.status >= 400 && e.response.status <= 499) {
                    if (e.response.data.errors) {
                        for (let key in e.response.data.errors) {
                            Notification.danger(e.response.data.errors[key])
                        }
                    } else {
                        Notification.danger("خطای ناخواسته ای پیش آمد")
                    }
                    return false;
                } else {
                    Notification.danger("خطای ناخواسته ای پیش آمد");
                    return false;
                }

            } else {
                Notification.danger("خطای ناخواسته ای پیش آمد");
                return false;
            }

        }

    }
};

export const editItems = (lastItems, newItem) => {
    return lastItems.map(item => {
        if (item.id === newItem.id) {
            return newItem
        } else {
            return item
        }
    });
};

export const loader = (status = false, isLoadMoreData) => {
    return false;

    if (isLoadMoreData) {
        try {
            status ? document.getElementById('mini-loader').classList.remove('d-none')
                : document.getElementById('mini-loader').classList.add('d-none');
        } catch (e) {}

    } else {
        try {
            status ? document.getElementById('loader').classList.remove('d-none')
                : document.getElementById('loader').classList.add('d-none');
        } catch (e) {}
    }

};

export const setRootScrollable = (status = true) => {

    try {
        status ? document.getElementById('root').classList.add('scrollable')
            : document.getElementById('root').classList.remove('scrollable');
    } catch (e) {}

};

export const traverse = (val) => {
    let regex = /[۰-۹]/g
    let str = val;
    let result = str.replace(regex, function (w) {
            return String.fromCharCode(w.charCodeAt(0) - 1728)
        }
    );
    return result;
};

export const isEmpty = (obj) => {
    for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false;
        }
    }

    return JSON.stringify(obj) === JSON.stringify({});
};

export const fixNumber = (str) => {
    let
        persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
        arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    if (typeof str === 'string') {
        for (let i = 0; i < 10; i++) {
            str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
    }
    return str;
};


export const isRequired = param => {
    throw new Error(`${param} is required`);
};

export const getMultiModeNumber = (number, gap = 2) => {
    return ("0" + number).slice(-gap);
};

export const separatePriceFormat = (number) => {
    if (!number) return '';
    return parseInt(number).toFixed(2).toString().replace(/\d(?=(\d{3})+\.)/g, "$&,").replace('.00', '')
};

export const responsiveDay = (day) => {
    if(window.screen.width > 992) {
        return day;
    }

    return day.substring(0, 1);
}
